import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/Assignment";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import Slide from "@material-ui/core/Slide";
import CustomInput from "components/CustomInput/CustomInput.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    getClinicUserId, getDateConverter,
    getReportTypes, verifyName, verifyPhoneNumber
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class BatchReport extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            open: true,
            alert: null,
            clinicMasterList: null,
            clinic_master_id: "",
            notFound: null,
            previewModal: false,
            selectedReport: null,
            name: "",
            reportLink: "",
            nameState: "",
            phoneNumber: "",
            phoneNumberState: "",

        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.searchOnFilter = this.searchOnFilter.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this)
        this.CreateAlert = this.CreateAlert.bind(this)
        this.handleClickOpen = this.handleClickOpen.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = () => {
        api.getFTPfiles({
            // "uploaded": true,
            "clinic_id": this.state.clinic_id,
            "clinic_master_id": this.state.clinic_master_id,
            "text": ""
        }).then(json => {
            this.setState({
                data: json.data.data
                /*data: json.data.data.map(item => {
                 return {
                 "_id": item._id,
                 "name": item.sync_data_custom ? item.sync_data_custom.name : "",
                 "paid": item.sync_data_custom ? item.sync_data_custom.paid : "",
                 "date": item.date,
                 "contact": item.sync_data_custom ? item.sync_data_custom.contact : "",
                 }
                 })*/
            })
        }).catch(error => {
            this.setState({notFound: error, data: []})
        });
        // isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
        //     api.listClinics().then(json => {
        //         this.setState({clinicsData: json.data.data})
        //     }) : this.setState({clinicsData: {}});
        api.getAllDoctors().then(json => {
            this.setState({doctorsData: json.data.data})
        });
        this.setState({clinic_id: getClinicUserId()})
    }

    componentDidMount() {
        this.CallReadApi();
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    searchOnFilter() {
        this.setState({data: null});
        var postBody = {
            clinic_id: this.state.clinic_id,
            patient_id: this.state.patientId,
            doctor_id: this.state.doctor_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            type: this.state.simpleSelect
        };
        api.getFTPfiles({
            // "uploaded": true,
            "clinic_id": this.state.clinic_id,
            "clinic_master_id": this.state.clinic_master_id,
            "text": ""
        }).then(json => {
            this.setState({
                /*data: json.data.data.map(item => {
                 return {
                 "_id": item._id,
                 "name": item.sync_data_custom ? item.sync_data_custom.name : "",
                 "paid": item.sync_data_custom ? item.sync_data_custom.paid : "",
                 "date": item.date,
                 "contact": item.sync_data_custom ? item.sync_data_custom.contact : "",
                 }
                 })
                 */
                data: json.data.data
            })
        }).catch(error => {
            this.setState({notFound: error, data: []})
        });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    };

    hideAlert() {
        this.setState({alert: null})
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Are you sure want to delete?"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="danger" onClick={() => {
                            this.deleteRecord(id)
                        }}>
                            Delete
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"_id": id, "updated_object": {}};
        api.deleteReport(postBody)
            .then(json => {
                this.searchOnFilter();
                this.setState({alert: null});
                //  window.location.reload();
            });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData, clinicMasterList} = this.state;
        const {classes} = this.props;
        if ((this.state.clinic_master_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinic_master_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinic_master_id)
        }
        if (this.state.data !== null && this.state.doctorsData && this.state.clinicMasterList)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        {/*{ mappingUI(Permissions.UploadReports) ? <GridItem xs={12} sm={12} md={2}>*/}
                        {/*<NavLink to={dashboardRouter("/report/add")}>*/}
                        {/*<Button block color="warning">*/}
                        {/*<Icon>add</Icon>*/}
                        {/*<span style={{paddingLeft: 10}}>ADD NEW</span>*/}
                        {/*</Button>*/}
                        {/*</NavLink>*/}
                        {/*</GridItem> : null}*/}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Batch Reports</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    List of all Reports
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <div>
                                        <GridContainer>
                                            <GridItem md={6} xs={12} sm={6} className="centerDiv">

                                                {isClinicMasterOrClinic() === "" ? <FormControl
                                                    fullWidth>
                                                    <InputLabel
                                                        htmlFor="clinic_master_id">
                                                        Clinic Master
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.clinic_master_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinic_master_id",
                                                            id: "clinic_master_id"
                                                        }}>
                                                        <MenuItem
                                                            disabled>
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicMasterList.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             style={{height: "1.8em"}}
                                                                             value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl> : null}
                                            </GridItem>
                                            {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinic_master_id ?
                                                <GridItem md={6} xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinic_id">
                                                            Clinic
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinic_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinic_id",
                                                                id: "clinic_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicsData.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl></GridItem>
                                                : null}
                                        </GridContainer>
                                        <br/><br/>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12} className="centerDiv">
                                                <Button color="warning" size="md"
                                                        onClick={this.searchOnFilter}>Search</Button>
                                            </GridItem>
                                        </GridContainer>

                                    </div>
                                    <br/>
                                    {data !== null && data.length >= 0 ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                                String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Uploaded File Name",
                                                            accessor: "file_name",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}>
                                                                            {data[index].file_name ? this.getFileName(data[index].file_name) : "No Name"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["file_name"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Date",

                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].created_at ? getDateConverter(data[index].created_at) : "No Date"}</p>

                                                                    </div>
                                                                ),
                                                            /*filterable: false,
                                                             sortable: false,*/
                                                        },
                                                        {
                                                            Header: "Report Created",
                                                            accessor: "uploaded",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].uploaded ? "Report Created" : "Not Created"}</p>

                                                                    </div>
                                                                ),
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                            // filterAll: true

                                                        },
                                                        {
                                                            Header: "Reason",
                                                            accessor: "notes",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>
                                                                            {data[index].notes ? data[index].notes : "-"}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            /*filterable: false,
                                                             sortable: false,*/
                                                        },

                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                    {data[index].report_id ?
                                                                        <NavLink
                                                                            to={data[index].report_id ? dashboardRouter(`/report/view/${data[index].report_id}`) : "#"}>
                                                                            <Tooltip
                                                                                id="tooltip-top"
                                                                                title="View"
                                                                                placement="bottom"
                                                                                classes={{tooltip: classes.tooltip}}>
                                                                                <Button type="button" color="info"
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            marginLeft: '10%'
                                                                                        }}>
                                                                                    <Icon
                                                                                        style={{fontSize: 20}}>info</Icon>
                                                                                </Button></Tooltip> </NavLink>
                                                                        : null}
                                                                    {data[index].report_id ? <NavLink
                                                                        to={data[index].report_id ? dashboardRouter(`/report/update/${data[index].report_id}`) : "#"}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Edit"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="success"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '5%'
                                                                                    }}>
                                                                                <Icon style={{fontSize: 20}}>edit</Icon>
                                                                            </Button></Tooltip>
                                                                    </NavLink> : <Tooltip
                                                                        id="tooltip-top"
                                                                        title="Edit"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="success"
                                                                                style={{
                                                                                    padding: 8,
                                                                                    marginLeft: '10%'
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.handleClickOpen("previewModal");
                                                                                    this.setState({
                                                                                        selectedReport: data[index],
                                                                                        name: data[index].data_extracted && data[index].data_extracted.name ? data[index].data_extracted.name : "",
                                                                                        nameState: data[index].data_extracted && data[index].data_extracted.name ? "success" : "",
                                                                                        phoneNumberState: data[index].data_extracted && data[index].data_extracted.mobile ? "success" : "",
                                                                                        phoneNumber: data[index].data_extracted && data[index].data_extracted.mobile ? data[index].data_extracted.mobile : "",
                                                                                        reportLink: data[index].file_link ? data[index].file_link : "",

                                                                                    })
                                                                                }}>
                                                                            <Icon style={{fontSize: 20}}>edit</Icon>
                                                                        </Button></Tooltip>}

                                                                </div>)
                                                        }]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null
                                    }
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                    <Dialog
                        maxWidth="lg"
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.previewModal}
                        TransitionComponent={Transition}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description" keepMounted
                        onClose={() => this.handleClose("previewModal")}>
                        <DialogTitle id="alert-dialog-title">{"Update Report"}</DialogTitle>
                        <DialogActions style={{margin: '8px auto', width: '900px', textAlign: 'left'}}>
                            <GridContainer style={{padding: '20px'}}>
                                <Grid item xs={12}>
                                    <GridContainer style={{padding: '20px'}}>
                                        <Grid item xs={12}>
                                            <GridContainer style={{padding: '20px'}}>

                                                <GridItem xs={12} sm={6}>
                                                    <CustomInput
                                                        labelText="Name"
                                                        success={this.state.nameState === "success"}
                                                        error={this.state.nameState === "error"}
                                                        id="name"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "name", "name"),
                                                            value: this.state.name,

                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <CustomInput
                                                        labelText="Phone Number"
                                                        success={this.state.phoneNumberState === "success"}
                                                        error={this.state.phoneNumberState === "error"}
                                                        id="phonenumber"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "phoneNumber", "phonenumber", "required"),
                                                            value: this.state.phoneNumber,
                                                        }}
                                                    />
                                                </GridItem></GridContainer>
                                            <div className="text-center margin-auto"><Button color="warning"
                                                                                             onClick={() => {
                                                                                                 this.typeClick();
                                                                                                 this.handleClose("previewModal")
                                                                                             }}>
                                                Update
                                            </Button>
                                                <Button
                                                    onClick={() => this.handleClose("previewModal")}>
                                                    Cancel
                                                </Button></div>
                                            <Card component="div" style={{margin: '10px', padding: '30px'}}>
                                                <div style={{padding: "5px"}}>
                                                    <GridContainer key={Math.random()}>
                                                        {this.state.selectedReport !== null ? showReport(this.state.reportLink) : null}
                                                    </GridContainer>
                                                </div>
                                            </Card>
                                        </Grid>

                                    </GridContainer>
                                </Grid>

                            </GridContainer>
                        </DialogActions>
                        <DialogActions style={{margin: '8px auto'}}>

                        </DialogActions>
                    </Dialog>

                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>
        )
    }

    handleClickOpen(modal) {
        var x = [];
        x[modal] = true;
        this.setState(x);
    }

    handleClose(modal) {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }


    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        if (stateName === "username" && this.state.username.length > 3 && this.state.usernameState === "success") {
            api.validateUser({"username": event.target.value}).then(json => {
                this.setState({validation: json.data.data.valid})
            })
        }
        switch (type) {
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;

                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});

        } else if (this.state.phoneNumber === "") {
            this.setState({phoneNumberState: "error"});
            this.props.id.generateNotification({message: "Please fill the number!", color: "danger"});

        } else if (this.state.nameState === "success" &&
            this.state.phoneNumberState === "success" && this.state.selectedReport._id) {
            var data = {
                "_id": this.state.selectedReport._id,
                "name": this.state.name,
                "contact": this.state.phoneNumber,
                "paid": true
            };
            api.updateFTPfile(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Report Update Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/report/getbatchfiles`))
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    getFileName(fileName) {
        let name = fileName.split("_");
        let temp = name.shift();
        if (fileName.split("_").length > 1) {
            return name.join("_")
        } else {
            return fileName
        }
    }

}

function showReport(url) {
    var type = url.substr(-3).toLowerCase();
    switch (type) {
        case ("pdf"):
            return <object data={url}
                           type="application/pdf"
                           width="800" height="1200">
                <div className="centerDiv"
                     style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                    href={url}>
                    <Button block size="lg" color="success">
                        Open Report
                    </Button></a></div>
            </object>;
        case ("doc"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("dot"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case("jpeg"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        case("jpg"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        case ("png"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        default:
            return <div className="centerDiv"
                        style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                href={url}><Button block
                                   size="lg"
                                   color="success">
                Open Report
            </Button></a></div>
    }
}

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

export default withStyles(styles)(BatchReport);



// WEBPACK FOOTER //
// ./src/components/Reports/BatchReport.jsx